/* eslint-disable @typescript-eslint/ban-ts-comment */
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { AppState, useAppDispatch } from '../../../../services/store';
import {
  fetchSignal,
  getSignal,
  setSelectedSignal,
} from '../../../../services/store/modules/signal';
import { Signal } from '../../../../services/store/modules/signal/models';

type UseSignalReturnType = Signal & { error: boolean };

const useSignal = (id: string): UseSignalReturnType => {
  const dispatch = useAppDispatch();
  const [error, setError] = useState(false);

  useEffect(() => {
    dispatch(setSelectedSignal(id));
    const fetchSignalData = async () => {
      try {
        // @ts-ignore unwrap() is required so that the error is thrown correctly. However, there is a bug with RTK not resolving types correctly
        await dispatch(fetchSignal(id)).unwrap();
      } catch (e) {
        setError(true);
      }
    };

    fetchSignalData().catch(console.error);

    return () => {
      dispatch(setSelectedSignal(undefined));
    };
  }, [dispatch, id]);

  // NOTE: couldn't work out how to use a selector with a parameter with `useHook`.
  const signal = useSelector((state: AppState) => getSignal(state, id));

  return { ...signal, error } || {};
};

export default useSignal;
